import logo from './img/elite-logo.png';
import footerBackground from './img/footer2.png';
import contactMap from './img/map-contact.png';
import customerHotelImage from './img/gallSlider/20.png';
import loginBackground from './img/admingall/loginbg.png';

export const hotelAssets = {
  logo,
  navBackground: footerBackground,
  footerBackground,
  contactHero:
    'https://prodimagesbucket.blob.core.windows.net/hotel-images/27960/da41797a-2a52-41ad-96c6-07fc57325dcf',
  contactMap,
  customerHotelImage,
  loginBackground,
};
